import ActionTypes from './types';

// types

export const REQUEST_CAM_UNIT = 'camera/REQUEST_CAM_UNIT';
export const REQUEST_CAM_LIST = 'camera/REQUEST_CAM_LIST';
export const GET_CAM_LIST = 'camera/GET_CAM_LIST';
export const SET_CAM_LIST = 'camera/SET_CAM_LIST';

export function requestCamUnit(event_id, camera_id) {
  return {
    type: ActionTypes.REQUEST_CAM_UNIT,
    // receivedAt: Date.now(),
  };
}

export function requestCamList(event_id) {
  return {
    type: ActionTypes.REQUEST_CAM_LIST,
    event_id,
    // receivedAt: Date.now(),
  };
}

export function getCamList(all) {
  return {
    type: ActionTypes.GET_CAM_LIST,
    payload: all,
    updatedAt: Date.now(),
  };
}

export function setCamList(all) {
  return {
    type: ActionTypes.SET_CAM_LIST,
    payload: all,
  };
}
